import { type ComputedRef, type Ref } from 'vue'
import { useSimpleErrorCollection } from '@/helpers/errors'
import type { ErrorCollection } from '@/helpers/errors/collection'
import { useEmailError } from '@/composables/useEmailError'
import type { Email } from '@/types/email'

export interface EmailAndNamesFieldsError {
    submit(): void
    errorsWithFeValidation: ComputedRef<ErrorCollection>
}

export const useEmailFieldError = (
    email: Readonly<Ref<string>>,
    validatedEmail: Ref<Email | ''>,
    submitHandler: () => void
): EmailAndNamesFieldsError => {
    const { error: emailError, validate: validateEmail } = useEmailError(
        email,
        ['customer', 'email']
    )

    const errorsWithFeValidation = useSimpleErrorCollection([emailError])

    const submit = () => {
        const validEmail = validateEmail() || ''

        if (!validEmail) {
            return
        }

        validatedEmail.value = validEmail

        submitHandler()
    }

    return {
        submit,
        errorsWithFeValidation,
    }
}
